import { useRuntimeConfig } from '#imports'
import qs from 'qs'
import { ElMessage } from 'element-plus'
import pkg from '../package.json'
import { calcInitTime, initTimestamp, reqSign } from '@/utils/sign'
import useStore from '@/stores/defaultStore'
import { v4 as uuidv4 } from 'uuid'
import { isMobile } from '@/utils/systemInfo'

// 后续需要如 FormData 再扩展
interface Config {
  url: string
  method?: string
  data?: any
  params?: any
  responseType?: 'json' | 'blob' | 'text' | 'raw'
  headers?: HeadersInit
  mute?: boolean
}

export default async function request(config: Config) {
  if (!initTimestamp) {
    await calcInitTime()
  }
  const env = useRuntimeConfig()
  let url = ''
  if (config.url.includes('http')) {
    url = config.url
  } else {
    url = env.public.proxyTarget + config.url
  }
  if (config.params) {
    url += '?' + qs.stringify(config.params)
  }
  const store = useStore()
  !store.deviceId && (await store.setDeviceId())
  const requestInit: RequestInit = {
    method: config.method || 'get',
    headers: {
      time: '' + (initTimestamp + Math.floor(performance.now())),
      reqId: uuidv4(),
      os: 'H5',
      deviceId: store.deviceId,
      deviceType: isMobile() ? 'mobile' : 'desktop',
      deviceVersion: isMobile() ? 'mobile' : 'desktop',
      appVersion: pkg.version.split('.').slice(0, 3).join('.'),
      keyVersion: env.public.secretKey.split(',')[0],
      from: '1',
      ...config.headers
    }
  }
  requestInit.headers['sign'] = reqSign({
    method: requestInit.method,
    headers: requestInit.headers,
    data: config.data
  })
  if (config.data) {
    requestInit.body = JSON.stringify(config.data)
    requestInit.headers['Content-Type'] = 'application/json;charset=UTF-8'
  }

  const raw = await fetch(url, requestInit).catch((err) => {
    console.error(err)
    return err
  })
  if (!raw.status) {
    !config.mute && ElMessage.error('未知异常')
    return Promise.reject(raw)
  }
  if (raw.status !== 200) {
    !config.mute && ElMessage.error(raw.status + ' ' + raw.statusText)
    return Promise.reject(raw)
  }
  switch (config.responseType) {
    case 'blob':
      return raw.blob()
    case 'text':
      return raw.text()
    case 'raw':
      return raw.json()
    case 'json':
    default:
      const res = await raw.json()
      if (+res.code === 0) {
        return res.data
      } else {
        !config.mute && ElMessage.error(res.message || res.msg)
        return Promise.reject(res)
      }
  }
}
